import { API_URL } from '../../../config'
import store from '../../store'

export default {
  namespaced: true,

  actions: {
    async getEstadosTickets() {
      const response = await fetch(`${API_URL}/tickets/estados`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getTicketsDelUsuario({}, filtro) {
      const response = await fetch(`${API_URL}/tickets`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(filtro)
      })
      return response.json()
    },

    async getTicketsDelArea({}, filtro) {
      const response = await fetch(`${API_URL}/tickets/tickets-area`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(filtro)
      })
      return response.json()
    },

    async getTicketsDeLaEmpresa({}, filtro) {
      const response = await fetch(`${API_URL}/tickets/tickets-empresa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(filtro)
      })
      return response.json()
    },

    async nuevoTicket({}, payload) {
      const response = await fetch(`${API_URL}/tickets/nuevo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async getArchivos({}, payload) {
      const response = await fetch(`${API_URL}/tickets/archivos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async getComentarios({}, payload) {
      const response = await fetch(`${API_URL}/tickets/comentarios`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async nuevoComentario({}, payload) {
      const response = await fetch(`${API_URL}/tickets/nuevo-comentario`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },
    async cargarArchivos({}, payload) {
      const response = await fetch(`${API_URL}/tickets/cargar-archivos`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async getOrigenes() {
      const response = await fetch(`${API_URL}/tickets/origenes`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getInfoMesa() {
      const response = await fetch(`${API_URL}/tickets/info-mesa`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getTicketsMesa({}, payload) {
      const response = await fetch(`${API_URL}/tickets/mesa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })

      return response.json()
    },

    async getTiposTickets() {
      const response = await fetch(`${API_URL}/tickets/tipos`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })

      return response.json()
    },

    async getSolicitantes() {
      const response = await fetch(`${API_URL}/tickets/solicitantes`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })

      return response.json()
    },

    async getFamiliasSolicitantes() {
      const response = await fetch(`${API_URL}/tickets/familias-solicitantes`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })

      return response.json()
    },

    async getAreas() {
      const response = await fetch(`${API_URL}/tickets/areas`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async getPrioridades() {
      const response = await fetch(`${API_URL}/tickets/prioridades`, {
        method: 'GET',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        }
      })
      return response.json()
    },

    async asignarTicket({}, payload) {
      const response = await fetch(`${API_URL}/tickets/asignar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async editarTicket({}, payload) {
      const response = await fetch(`${API_URL}/tickets/editar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async finalizarTicket({}, payload) {
      const response = await fetch(`${API_URL}/tickets/finalizar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async autoasignarTicket({}, payload) {
      const response = await fetch(`${API_URL}/tickets/autoasignar`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async cargarTicketMesa({}, payload) {
      const response = await fetch(`${API_URL}/tickets/cargar-mesa`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },
    async nuevoTipo({}, payload) {
      const response = await fetch(`${API_URL}/tickets/nuevo-tipo`, {
        method: 'POST',
        headers: {
          'Content-Type': 'Application/json',
          Authorization: store.state.token
        },
        body: JSON.stringify(payload)
      })
      return response.json()
    },

    async permisos() {
      const response = await fetch(`${API_URL}/tickets/permisos`, {
        method: 'GET',
        headers: {
          'Contente-Type': 'Application/json',
          Authorization: store.state.token
        }
      })

      return response.json()
    }
  }
}
